import ApiService from "../../api.service";

export const GET_ENTRANCE_EXAM_SCHEDULE = "customer/exam-schedule";
export const REGISTER_ENTRANCE_EXAM = "customer/register-entrance-exam";
export const GET_RESULT_ENTRANCE_EXAM = "contract/result-entrance-exam";
export const CHECK_STATUS_ENTRANCE_EXAM = "marking-exam-retake/check-status-entrance-exam";
export const UPDATE_NEED_ENTRANCE_EXAM = "customer/update-need-entrance-exam";
export const CHECK_ENTRANCE_EXAM_BEFORE_CONSULT = "customer/check-entrance-exam-before-consult";
export const GET_LIST_EXAM = "customer/list-exam";

const actions = {
    [GET_ENTRANCE_EXAM_SCHEDULE](context, payload = {}) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_ENTRANCE_EXAM_SCHEDULE, payload).then(({ data }) => {
                resolve(data);
            }).catch(({ response }) => {
                reject(response);
            });
        });
    },
    [REGISTER_ENTRANCE_EXAM](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(REGISTER_ENTRANCE_EXAM, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },
    [GET_RESULT_ENTRANCE_EXAM](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_RESULT_ENTRANCE_EXAM, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },
    [CHECK_STATUS_ENTRANCE_EXAM](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`/${CHECK_STATUS_ENTRANCE_EXAM}/${payload.id}`, {
                type: payload.type
            })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },
    [GET_LIST_EXAM](context, payload = {}) {
        return new Promise((resolve, reject) => {
            ApiService.query(`/${GET_LIST_EXAM}/${payload.customer_id}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },
    [CHECK_ENTRANCE_EXAM_BEFORE_CONSULT](context, payload = {}) {
        return new Promise((resolve, reject) => {
            ApiService.query(`/${CHECK_ENTRANCE_EXAM_BEFORE_CONSULT}/${payload.customer_id}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },
    [UPDATE_NEED_ENTRANCE_EXAM](context, payload = {}) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${UPDATE_NEED_ENTRANCE_EXAM}/${payload.customer_id}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
};

export default {
    actions
};
